import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>PAYG or monthly contract?</Typography>

      <p className='-mt-2'>Smartix is designed to let you start small and scale as your use grows.</p>

      <p><strong>Pay As You Go (PAYG)</strong> gives you complete flexibility. Simply purchase credit bundles whenever you need them, with no ongoing commitment.
        It's ideal for lower volumes, occasional campaigns, events, trials, or organisations whose usage varies considerably from month to month.</p>

      <p><strong>Monthly contracts</strong> are designed for organisations with higher or more predictable usage.
        In return for a minimum monthly commitment, contract customers benefit from significantly lower credit costs — with rates reducing further as volume increases.</p>

      <p>A monthly contract may be worth considering if you:</p>
      <ul className='mb-5'>
        <il>regularly purchase PAYG credit bundles;</il>
        <il>expect to issue or manage a growing number of passes;</il>
        <il>use Smartix for ongoing customer engagement rather than occasional campaigns;</il>
        <il>need predictable monthly costs; or</il>
        <il>anticipate significantly increasing your Smartix usage.</il>
      </ul>

      <Typography variant='h6' className='pb-5'>Applying doesn't commit you to anything</Typography>

      <p className='-mt-2'>Tell us a little about your expected usage and we'll review it with you and recommend an appropriate monthly credit commitment and rate.</p>

      <p>There is no obligation to proceed. If PAYG still makes more sense for your expected usage, you can simply continue purchasing credits as you do today.</p>

      <p>As your usage increases, you can move from PAYG to a monthly contract without changing how you create, issue or manage your Smartix passes.</p>
    </div>
  )
}

export default HelpText